import React from 'react';
import PlayCircleFilled from '@mui/icons-material/PlayCircleFilled';

import VideoLiveAndUpcomingCardIndicator from './videoLiveAndUpcomingCardIndicator';

import styles from '../styles/videoLiveAndUpcomingCardMedia.module.scss';

export default function VideoLiveAndUpcomingCardMedia({ startAt, endAt }) {
  return (
    <>
      <VideoLiveAndUpcomingCardIndicator
        className={styles.liveIndicator}
        startAt={startAt}
        endAt={endAt}
      />
      <PlayCircleFilled className={styles.icon} sx={{ height: 44, width: 44 }} />
    </>
  );
}
